module.exports = __webpack_public_path__ + "img/premium-section-background1.80bfb92.jpg";